import {
  PapiDaSharedGiveLlama,
  PapiDaSharedPointsModal,
  PapiDaSharedPointsModalGive,
} from '@wix/da-papi-types';
import { SimpleXHREndpoint } from './constants';

export const getFakeResponse = endpoint => options => {
  if (process.env.NODE_ENV !== 'production') {
    switch (endpoint) {
      case SimpleXHREndpoint.GIVE_POINTS_POPUP: {
        const response: PapiDaSharedPointsModal = {
          pointsBalance: 10,
        };
        return response;
      }
      case SimpleXHREndpoint.GIVE_LLAMA: {
        const response = {} as PapiDaSharedGiveLlama; // BE is returning redundant session
        return response;
      }
      case SimpleXHREndpoint.GIVE_POINTS: {
        const response: PapiDaSharedPointsModalGive = {
          success: true,
        };
        return response;
      }
      default:
        return;
    }
  }
};
